import React from "react";

import svg from "../../assets/images/icons/expression-blue.svg";

export const ExpressionBlueIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Expression"}
    />
);
